// 📄 components/common/ProgressRow.tsx
// Fila con label + barra de progreso + fracción — usada en ProjectStatsPanel
// (GeneralStatsView y SolutionStatsView). `showStatusIcon` es opcional y solo
// lo usa SolutionStatsView (check verde si el canal está 100% completado);
// por defecto queda apagado para no alterar la vista General existente.
import React from 'react';
import { CheckCircle2, Circle } from 'lucide-react';

interface ProgressRowProps {
  label: string;
  completed: number;
  total: number;
  showStatusIcon?: boolean;
}

export default function ProgressRow({ label, completed, total, showStatusIcon = false }: ProgressRowProps) {
  const pct = total > 0 ? Math.round((completed / total) * 100) : 0;
  const barColor = pct === 100 ? '#10b981' : '#2563eb';
  return (
    <div className="space-y-1">
      <div className="flex justify-between items-center text-xs text-gray-400">
        <span>{label}</span>
        <span className="flex items-center gap-1.5">
          {total > 0 ? `${completed}/${total}` : 'N/A'}
          {showStatusIcon && (
            pct === 100
              ? <CheckCircle2 className="w-3.5 h-3.5 text-emerald-400" />
              : <Circle className="w-3.5 h-3.5 text-gray-600" />
          )}
        </span>
      </div>
      <div className="w-full bg-white/10 h-1.5 rounded-full overflow-hidden">
        <div
          className="h-full transition-all duration-300 rounded-full"
          style={{ width: `${pct}%`, background: barColor }}
        />
      </div>
    </div>
  );
}
